
import { defineComponent, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { Auth, Dict, DictItem } from '@loca/mfe-vue3'

export default defineComponent({
  name: 'EquipmentPage',

  setup() {
    const router = useRouter()
    let isFirstLoad = true

    // 获取设备管理的所支持列表
    function getEquipmentRoutes(): Promise<any[]> {
      return Dict.getDict('equipment_list_header_options')
        .then((dict: any) =>
          ((dict as DictItem[]) || []).map((item: DictItem) => ({
            route: item.value,
            auth: item.desc
          }))
        )
        .catch(() => [])
    }

    async function autoJump() {
      const equipmentRoutes = await getEquipmentRoutes()
      const permissions = Auth.getUserPermissions()
      let hasSomeAuth = false

      if (permissions && equipmentRoutes.length) {
        // 进入有权限的第一个页面
        hasSomeAuth = equipmentRoutes.some((item) => {
          const res = permissions.includes(item.auth)
          const preState = window.history.state
          if (res) window.history.replaceState({ ...preState }, '', item.route)
          return res
        })
      }

      if (!hasSomeAuth) router.push('/')
    }

    onActivated(autoJump)
  }
})
